"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnabledColumn = exports.ResultColumn = exports.LastModifiedByColumn = exports.TimeColumn = exports.NameSortColumn = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var SwitchBox_1 = __importDefault(require("@/react-app/common/components/SwitchBox"));
var store_1 = require("@/redux/store");
var ruleSlice_1 = require("../state/ruleSlice");
var i18n_1 = __importDefault(require("@/react-app/i18n"));
var date_1 = require("@/react-app/common/utils/date/date");
var getRuleActionColumnText = function (rule) {
    var action = i18n_1.default.t("AUTOMATION.DECISION_RULES.RULE_ACTION.".concat(rule.result));
    if (rule.result === 'REFUSE') {
        return "".concat(action, " (").concat(rule.decisionName, ")");
    }
    if (rule.result === 'MANUAL') {
        return "".concat(action, " (").concat(rule.routingQueueName, ")");
    }
    return action;
};
var getRuleActionColumnTitle = function (rule) {
    if (rule.result === 'MANUAL') {
        return rule.routingQueueName;
    }
    return rule.decisionName;
};
function NameSortColumn(_a) {
    var row = _a.row, filterViewHref = _a.filterViewHref;
    return (react_1.default.createElement("td", { className: "table-cell" },
        react_1.default.createElement("a", { className: "automation__table__link", href: filterViewHref(row) },
            react_1.default.createElement("span", { className: "truncated name-display", title: row.name },
                ' ',
                row.name,
                ' '),
            row.description && (react_1.default.createElement("span", { className: "automation__table__description--icon" },
                react_1.default.createElement("span", { className: "eva-tooltip" }, row.description))))));
}
exports.NameSortColumn = NameSortColumn;
function TimeColumn(_a) {
    var _b;
    var row = _a.row, filterViewHref = _a.filterViewHref, column = _a.column;
    var value = (row[column] || 0);
    var t = (0, react_i18next_1.useTranslation)().t;
    var timeZone = (0, date_1.getUserTimezone)();
    return (react_1.default.createElement("td", { className: "table-cell", title: (_b = t('DASHBOARD.STATISTICS.TIMEZONE_TOOLTIP_R18N', { timeZone: timeZone })) !== null && _b !== void 0 ? _b : '' },
        react_1.default.createElement("a", { className: "truncated automation__table__link", href: filterViewHref(row) }, (0, date_1.formatDate)(new Date(value)))));
}
exports.TimeColumn = TimeColumn;
function LastModifiedByColumn(_a) {
    var row = _a.row, filterViewHref = _a.filterViewHref;
    return (react_1.default.createElement("td", { className: "table-cell", title: row.lastModifiedBy },
        react_1.default.createElement("a", { className: "truncated automation__table__link", href: filterViewHref(row) }, row.lastModifiedBy)));
}
exports.LastModifiedByColumn = LastModifiedByColumn;
function ResultColumn(_a) {
    var row = _a.row, filterViewHref = _a.filterViewHref;
    return (react_1.default.createElement("td", { className: "table-cell", title: getRuleActionColumnTitle(row) },
        react_1.default.createElement("a", { className: "truncated automation__table__link", href: filterViewHref(row) }, getRuleActionColumnText(row))));
}
exports.ResultColumn = ResultColumn;
function EnabledColumn(_a) {
    var row = _a.row, domain = _a.domain;
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, store_1.useAppDispatch)();
    return (react_1.default.createElement("td", { title: t('AUTOMATION.DECISION_RULES.HEADER.STATUS') },
        react_1.default.createElement(SwitchBox_1.default, { checked: row.enabled, onToggle: function (checked) { return dispatch((0, ruleSlice_1.updateRuleStatus)({ domain: domain, id: row.id, enabled: checked })); } })));
}
exports.EnabledColumn = EnabledColumn;
